module.exports = __webpack_public_path__ + "static/media/play-player-shooting.f67c0450.png";